module.exports = __webpack_public_path__ + "static/media/linsay-smiling.c8f221f1.md";